import { type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';

import { I18nProvider } from 'src/i18n';
import { queryClient } from 'src/lib/query-client';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <I18nProvider>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </I18nProvider>
  );
}
